import React from "react";
import { Box } from "@mui/material";
import economicLogo from "../../assets/e-conomic_primary_logo_pos_rgb.png";

interface EconomicSignInButtonProps {
  onClick: () => void;
}

const EconomicSignInButton: React.FC<EconomicSignInButtonProps> = ({
  onClick,
}) => {
  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        userSelect: "none",
        WebkitAppearance: "none",
        backgroundColor: "white",
        backgroundImage: "none",
        border: "1px solid #747775",
        borderRadius: "20px",
        boxSizing: "border-box",
        color: "#1f1f1f",
        cursor: "pointer",
        fontFamily: "'Roboto', arial, sans-serif",
        fontSize: "14px",
        height: "40px",
        letterSpacing: "0.25px",
        outline: "none",
        overflow: "hidden",
        padding: "0 16px",
        position: "relative",
        textAlign: "center",
        transition:
          "background-color .218s, border-color .218s, box-shadow .218s",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
        width: "auto",
        maxWidth: "400px",
        minWidth: "min-content",
        "&:hover": {
          boxShadow:
            "0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15)",
        },
        "&:hover .button-state": {
          backgroundColor: "#303030",
          opacity: 0.08,
        },
        "&:active .button-state, &:focus .button-state": {
          backgroundColor: "#303030",
          opacity: 0.12,
        },
        "&:disabled": {
          cursor: "default",
          backgroundColor: "rgba(255, 255, 255, 0.38)",
          borderColor: "rgba(31, 31, 31, 0.12)",
        },
        "&:disabled .button-contents, &:disabled .button-icon": {
          opacity: 0.38,
        },
      }}
    >
      <Box
        className="button-state"
        sx={{
          transition: "opacity .218s",
          bottom: 0,
          left: 0,
          opacity: 0,
          position: "absolute",
          right: 0,
          top: 0,
        }}
      />
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          height: "100%",
          justifyContent: "center",
          position: "relative",
          width: "100%",
        }}
      >
        <Box
          className="button-icon"
          sx={{
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={economicLogo}
            alt="e-conomic"
            style={{ height: "24px", width: "auto" }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default EconomicSignInButton;
